import React from 'react';

import { useEditorNode, useNodeContext } from 'craft/hooks';

import { EmptyState } from './components/EmptyState';
import { IFramePreview } from './components/IFramePreview';

interface Props {
  src?: string;
}

const isSafeSrc = (src: string) => {
  const allowedProtocols = ['https:', 'http:'];

  try {
    const url = new URL(src);
    if (!allowedProtocols.includes(url.protocol)) {
      return false;
    }
  } catch (error) {
    return false;
  }

  return true;
};

const IFrameEmbed = ({ src }: Props) => {
  const { id } = useNodeContext();
  const { setProps } = useEditorNode(id);

  const setSrc = (newSrc: string) => {
    setProps({ src: newSrc.trim() });
  };

  if (!src || src === 'https://') {
    return <EmptyState setSrc={setSrc} />;
  }

  if (!isSafeSrc(src)) {
    return <IFramePreview src="" />;
  }

  return <IFramePreview src={src} />;
};

export default IFrameEmbed;
